/* ── portal.js ── */
/* 統一入口（D27）：登入後首頁。摘要一包來自 /portal/summary（角色感知），點卡進各系統。
   只掛在 index.html；不動庫存的 API.init 快取。 */
const user = API.me();
if (!user) location.replace('login.html');

const $ = (s) => document.querySelector(s);
let _tmr;
// popover 顯示/收合走 who.js 的共用殼 toastPop/toastPopHide（09/24 review ⑥ 五處合一）
function toast(m) {
  const t = $('#toast');
  $('#toast-msg').textContent = m;
  toastPop(t);
  clearTimeout(_tmr); _tmr = setTimeout(() => toastPopHide(t), 2600);
}
window.portalLogout = () => { apiLogout(); location.replace('login.html'); };
window.goInv = () => { location.href = 'inventory.html'; };
window.goHR = () => { location.href = 'scoring.html'; };
window.goShip = () => { location.href = 'shipping.html'; };
window.goMeasure = () => { location.href = 'measure.html'; };

// ── 生產紀錄入口旗標（150-6，老闆 10/12 定案：掛正式站、對一般使用者隱藏）──
// 'units'＝試用期（管理員＋MEASURE_UNITS 裡的單位才看得到卡）｜'all'＝全面開放｜'off'＝隱藏
// 10/14 開放給總店（出貨檢查要店裡登記）；直接打網址者由後端 API 權限把關（店端只能寫出貨/同步）。
const SHOW_MEASURE = 'units';
const MEASURE_UNITS = ['FACTORY', 'STORE_KEELUNG'];   // 後場、九如總店
const measureVisible = (isAdmin2, unitCode) =>
  SHOW_MEASURE === 'all' || (SHOW_MEASURE === 'units' && (isAdmin2 || MEASURE_UNITS.includes(unitCode)));

const ICON_INV = '<svg viewBox="0 0 24 24"><path d="m7.5 4.27 9 5.15"/><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z"/><path d="m3.3 7 8.7 5 8.7-5"/><path d="M12 22V12"/></svg>';
const ICON_HR = '<svg viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>';
const ICON_SHIP = '<svg viewBox="0 0 24 24"><path d="M10 17h4V5H2v12h3"/><path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5"/><path d="M14 17h1"/><circle cx="7.5" cy="17.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>';
const ICON_MEASURE = '<svg viewBox="0 0 24 24"><path d="M9 11h6"/><path d="M9 15h4"/><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M19.5 8 14 2.5A1.5 1.5 0 0 0 12.9 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.1c0-.4-.16-.78-.5-1.1Z"/></svg>';
// 150-9 動態摘要：卡先畫殼、/measure/day 回來再補三列（失敗退回靜態文字，不擋入口）
const measureCard = () => card(ICON_MEASURE, '生產紀錄', '試用中',
  '<div id="measure-rows"><p class="muted-sm" style="padding:6px 0;">載入今日進度…</p></div>', 'goMeasure', '進入生產紀錄');
const escP = (v) => String(v ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
// store＝總店身分（unitId＝自己的單位，篩「我登記的」）；其他身分維持後場視角三列
async function fillMeasureCard(todayDs, store, unitId) {
  const el = document.getElementById('measure-rows');
  if (!el || !todayDs) return;
  try {
    // 出貨待複驗 10/14 起跨日（不分哪天登記的）——讀佇列；佇列失敗不影響其他兩列
    const yDs = (() => { const t = new Date(todayDs + 'T00:00:00'); t.setDate(t.getDate() - 1); return t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0'); })();
    const [r, q, od, y] = await Promise.all([apiFetch('/measure/day/' + todayDs, { timeoutMs: 15000 }),
      apiFetch('/measure/ship', { timeoutMs: 15000 }).catch(() => null),
      apiFetch('/measure/orders', { timeoutMs: 15000 }).catch(() => null),   // 10/19：後場版也看訂單（要照單備貨）
      apiFetch('/measure/day/' + yDs, { timeoutMs: 15000 }).catch(() => null)]);   // 10/19：昨天填的＝今天開店用
    const d = r.data || {};
    const sy = d.sync || {};
    // 10/19 兩天並列：「今天開店 剩餘 12・預留 55｜明天 預留未填」——昨晚店剩多少、昨天後場留多少，過了 00:00 也看得到；
    // 後段是自己今天該填的。後場休假（人事班表連動）那天預留不催填
    const syY = ((y || {}).data || {}).sync || {};
    // 10/19 使用者：一列塞兩邊會折行、也看不出誰是誰——拆成「後場預留」「門市剩餘」兩列，各寫昨天／今天；
    // 自己該填的沒填標橘字「未填」，對方的沒填灰字「尚未回報」，後場休假那天預留標（後場休假）
    // 管理員（unitId 空）不是填的人、是盯兩邊有沒有填的人：兩邊沒填都標「未填」
    const admin = unitId == null;
    const cell = (v, own, rest) => v != null ? v : rest ? '（後場休假）' : own ? '<span class="warn">未填</span>' : '<span class="muted">尚未回報</span>';
    // 10/20 使用者：標題就叫「同步盤數」，右邊上下兩行——後場留／總店剩，各寫昨天・今天
    const syncRow = () => row('同步盤數',
      '<div style="line-height:1.55;"><span class="muted" style="font-weight:700;">後場留</span> ' + (y ? '昨天 ' + cell(syY.reserve, admin || !store, !!y.factory_rest) : '昨天 —') + '・今天 ' + cell(sy.reserve, admin || !store, !!r.factory_rest) + '</div>' +
      '<div style="line-height:1.55;"><span class="muted" style="font-weight:700;">總店剩</span> ' + (y ? '昨天 ' + cell(syY.left, admin || store, false) : '昨天 —') + '・今天 ' + cell(sy.left, admin || store, false) + '</div>');
    // 10/15：訂單列看「還沒到期的訂單」（跨日）——最近要的一張＋還有幾張；寫法同同步頁「10/18 13:00 要・自取 282 條」
    const orderRow = () => { const os = od ? (od.orders || []).filter(o => !o.cancel) : null;   // 已取消的不算
      if (os == null) return row('訂單回報', '—');
      if (!os.length) return row('訂單回報', '沒有未到期訂單');
      const o = os[0];
      return row('訂單回報', '<span style="color:var(--orange);">' + mdOf(o.date) + (o.time ? ' ' + escP(o.time) : '') + ' 要・' + escP(o.order) + '</span>' +
        (os.length > 1 ? '・還有 ' + (os.length - 1) + ' 張' : ''));
    };
    if (store) {
      // 10/14 照 10/08 量測入口模擬稿的總店版：出貨檢查／同步盤數／訂單回報
      const mine = q ? [...q.pending, ...q.done].filter(x => x.regUnit == null || x.regUnit === unitId) : null;
      const todayN = mine ? mine.filter(x => x.day === todayDs).length : null;
      const pendN = q ? q.pending.filter(x => x.regUnit == null || x.regUnit === unitId).length : null;
      el.innerHTML =
        row('出貨檢查', mine == null ? '—'
          : (todayN ? '今日登記 ' + todayN + ' 台' : '<span class="warn">今日尚未檢查</span>') +
            (pendN ? '・' + pendN + ' 台待後場複驗' : '')) +
        syncRow() +
        orderRow();
      return;
    }
    const doneN = ['mix', 'scale', 'ferment', 'fry'].filter(k => (d.doneSt || {})[k]).length;
    const frozen = (d.vats || []).reduce((a, v) => a + (v.mode !== 'all' ? (+v.frozen || 0) : 0), 0);
    const rate = d.shape && d.shape.count ? ((frozen + (+d.shape.fried || 0)) / d.shape.count * 100) : null;
    const pend = q ? q.pending.length : null;
    // 10/19 使用者：後場版也要看同步盤數（自己要填預留）與訂單（要備貨）——從後場角度寫：門市剩餘／我方預留
    el.innerHTML = row('今日站點完成', doneN > 0 ? doneN + '/4 站' : '<span class="warn">尚未開始</span>') +
      row('今日良率', rate != null ? rate.toFixed(1) + '%' : '—') +
      row('出貨複驗', pend == null ? '—' : pend ? '<span class="warn">' + pend + ' 台待複驗</span>' : '無待辦') +
      syncRow() +
      orderRow();
  } catch (e) {
    el.innerHTML = '<p class="muted-sm" style="padding:6px 0;">站點量測六站・同步盤數・當日完成度</p>';
  }
}

const mdOf = (ds) => ds ? (+ds.slice(5, 7)) + '/' + (+ds.slice(8)) : '—';
const row = (k, v) => '<div class="row"><span>' + k + '</span><b>' + v + '</b></div>';
const drow = (k, v, off) => '<div class="drow"><span class="k">' + k + '</span><span class="v' + (off ? ' off' : '') + '">' + v + '</span></div>';

function invRows(inv, label) {
  const pre = label ? label + '：' : '';
  let h = row(pre + '今日異動', inv.moves_today > 0 ? inv.moves_today + ' 筆' : '<span class="warn">尚未記錄</span>');
  // 09/04 使用者需求：主管卡補每天有用的三樣（admin 兩單位彙總維持精簡，不加）
  if (!label && inv.daily_total != null) {
    h += row('今日盤點', inv.daily_total > 0
      ? (inv.daily_counted >= inv.daily_total
        ? '每日品項 ' + inv.daily_counted + '/' + inv.daily_total
        : '<span class="warn">每日品項 ' + inv.daily_counted + '/' + inv.daily_total + '</span>')
      : '—');
  }
  // 09/04 回饋：品名不列（手機折行醜），只顯示項數
  h += row(pre + '低庫存警示', inv.low_stock > 0 ? '<span class="warn">' + inv.low_stock + ' 項</span>' : '0 項');
  if (!label && inv.expiry_soon != null) {
    h += row('近效期批次', inv.expiry_soon > 0
      ? (inv.expiry_urgent > 0
        ? '<span class="warn">' + inv.expiry_soon + ' 批（7 天內 ' + inv.expiry_urgent + '）</span>'
        : inv.expiry_soon + ' 批')
      : '0 批');
  }
  return h + row(pre + '進行中調撥', inv.open_transfers + ' 筆') +
    row(pre + '上次盤點', mdOf(inv.last_count_date));
}
function hrRowsManager(hr, todayDs) {
  const dow = '日一二三四五六'[new Date(todayDs + 'T00:00:00').getDay()];
  let h = '<div class="day-head"><span class="d">' + mdOf(todayDs) + '<small>週' + dow + '</small></span><span class="today">TODAY</span></div>';
  if (hr.holiday) return h + drow('國定假日', hr.holiday, true) + drow('今日評分', '—');
  if (hr.rest) return h + drow('今日', '全廠固定休') + drow('今日評分', '—');
  h += drow('休假人員', hr.offs.length ? hr.offs.join('、') : '無', hr.offs.length > 0);
  // 09/04 使用者需求：總店卡照紙本日誌顯示完整當日班表（開店/值班/20:00/關帳/洗餐具/清潔/備註）
  if (hr.shift) {
    const v = (x) => x || '—';
    // 09/04 回饋：清潔項目照固定順序（同班表的星期任務順序），不吃資料存入順序
    const CLEAN_ORDER = ['果汁', '廁所', '玻璃(白天)', '玻璃(晚上)', '刷地'];
    const ci = (t) => { const i = CLEAN_ORDER.indexOf(t); return i < 0 ? 99 : i; };
    const clean = Object.entries(hr.clean || {}).sort((a, b) => ci(a[0]) - ci(b[0]))
      .map(([t, p]) => t + '：' + p).join('<br>');
    h += drow('開店', v(hr.shift.open)) +
      drow('當天值班', v(hr.shift.duty)) +
      drow('20:00', v(hr.shift.t20)) +
      drow('關帳', v(hr.shift.close)) +
      drow('洗餐具', v(hr.dish)) +
      drow('清潔事項', clean || '—') +
      (hr.shift.note ? drow('備註', hr.shift.note) : '');
  } else {
    h += drow('今日值班', hr.duty.length ? hr.duty.join('、') : '—');
  }
  h += drow('今日評分', hr.scored > 0 ? '已評 ' + hr.scored + ' 人' : '<span class="warn">今日尚未評分</span>');
  return h;
}
// 09/04 回饋：admin 庫存卡太長——一單位一列精簡摘要（同人事卡 hrRowAdmin 風格）
function invRowAdmin(u) {
  const inv = u.inventory || {};
  // 去空格＋字級微縮（09/04：手機上兩單位列都要單行、排版一致）；
  // 各段自帶 nowrap 保底——數字極端變寬時只在「・」處整段換行，不會裁到卡外
  const seg = (s) => '<span style="white-space:nowrap;">' + s + '</span>';
  const val = [seg('異動' + (inv.moves_today || 0)),
    seg('低庫存' + (inv.low_stock > 0 ? '<span class="warn">' + inv.low_stock + '</span>' : '0')),
    seg('調撥' + (inv.open_transfers || 0)),
    seg('盤點' + mdOf(inv.last_count_date))].join('・');
  return '<div class="row"><span>' + u.name + '</span><b style="font-size:.78rem;">' + val + '</b></div>';
}
function hrRowAdmin(u) {
  const hr = u.hr;
  if (hr.rest) return row(u.name, '全廠固定休');
  return row(u.name, '值班 ' + hr.duty.length + '・休 ' + hr.offs.length + '・' +
    (hr.scored > 0 ? '已評 ' + hr.scored : '<span class="warn">未評</span>'));
}

function card(icon, title, tag, body, goFn, goTxt) {
  return '<div class="app" onclick="' + goFn + '()">' +
    '<div class="top"><span class="ic">' + icon + '</span><b>' + title + '</b>' + (tag ? '<span class="tag">' + tag + '</span>' : '') + '</div>' +
    body + '<div class="go">' + goTxt + ' →</div></div>';
}

function renderSummary(s) {
  // 部署中後端可能回 200 但內容不完整——先驗形狀再動畫面，讓呼叫端（開機/恢復重試）走失敗路徑
  if (!s || !Array.isArray(s.units)) throw new Error('摘要內容不完整');
  if (window.ntfCacheSum) ntfCacheSum(s);   // 09/16 開機去重：點卡進子系統 30 秒內鈴鐺直接沿用這份
  // 摘要回來後用權威單位代碼校正徽章——只改字、不重畫元件
  //（09/15 修：原本整個 whoBoot 重畫會把使用者剛點開的選單從 DOM 拔掉）
  const whoBadge = document.querySelector('#who-wrap .who-badge');
  const whoCh = s.role === 'admin' ? '管' : (s.units[0] && s.units[0].code === 'FACTORY' ? '後' : '總');
  if (whoBadge && whoBadge.textContent !== whoCh) whoBadge.textContent = whoCh;
  if (window.notifyRender) notifyRender(s);   // 09/10 通知中心：同一包摘要餵鈴鐺
  $('#today').textContent = s.today;
  let apps = '';
  const shipRows = (sh) =>
    row('今日出貨單', sh.today_orders + ' 張') +
    row('待驗收', sh.to_confirm > 0 ? '<span class="warn">' + sh.to_confirm + ' 張</span>' : '0 張');
  if (s.role === 'admin') {
    apps += card(ICON_INV, '庫存系統', '全單位',
      s.units.map(invRowAdmin).join(''), 'goInv', '進入庫存');
    apps += card(ICON_HR, '人事評分', '全單位',
      s.units.map(hrRowAdmin).join('') +
      row('待審核申請', s.pending_requests > 0 ? '<span class="warn">' + s.pending_requests + ' 件</span>' : '0 件'),
      'goHR', '進入人事評分');
    const shipU = s.units.find(u => u.shipping);
    if (shipU) apps += card(ICON_SHIP, '出貨管理', '開單・司機連結', shipRows(shipU.shipping), 'goShip', '進入出貨');
    if (measureVisible(true, null)) apps += measureCard();
    $('#note').textContent = '摘要為兩單位即時彙總；點卡進入後可切換單位。';
  } else {
    const u = s.units[0] || { hr: { rest: false, duty: [], offs: [], scored: 0 }, inventory: {} };
    apps += card(ICON_INV, '庫存系統', u.name, invRows(u.inventory, ''), 'goInv', '進入庫存');
    apps += card(ICON_HR, '人事評分', u.name, hrRowsManager(u.hr, s.today), 'goHR', '進入人事評分');
    if (u.shipping) apps += card(ICON_SHIP, '出貨管理', '看單・驗款', shipRows(u.shipping), 'goShip', '進入出貨');
    if (measureVisible(false, u.code)) apps += measureCard();
    $('#note').textContent = '摘要為即時資料；有申請待老闆審核時會在人事系統內顯示。';
  }
  $('#apps').innerHTML = apps;
  // 10/26 通知搬入口：橫幅照權限狀態畫；已授權的裝置順便同步訂閱（鑰匙換了自動退訂重訂）。
  // admin 的 /push/subscribe 要帶單位（任一有效單位即可，admin 訂閱收全部單位的推播）
  const pushUnit = s.role === 'admin' ? (s.units[0] && s.units[0].unit_id) : null;
  if (window.jrPush) { jrPush.renderBar('push-bar', pushUnit); jrPush.sync(pushUnit); }
  const u0 = s.role !== 'admin' && s.units[0];   // 總店主管看總店版摘要（出貨檢查／盤數／訂單）
  fillMeasureCard(s.today, !!(u0 && u0.code === 'STORE_KEELUNG'), u0 ? u0.unit_id : null);   // 生產紀錄卡動態摘要（卡不存在時函式自己略過）
}

// 09/23 部署空窗實案：降級後原本不會再抓摘要，「稍後會自動恢復」是空話——
// 頁面就一直掛著降級卡直到手動重整。改成降級後每 30 秒背景重試（網路恢復事件也立即試），
// 抓到就換回正常卡片、停止重試，讓文案成真。
// 09/23 code review 二修：①busy 互斥＋先清計時器——30 秒輪與 online 事件同時觸發時
// 原版會漏掉一個計時器變成雙迴圈（恢復後重畫多次、提示連跳）；
// ②「renderSummary 成功才算恢復」——後端回 200 但內容不完整時原版先拆 online 快速通道
// 再炸在渲染上，之後只剩無聲的失敗輪；現在渲染丟例外一律回到 catch 續退避，通道不拆。
let _retryTmr = null, _retryBusy = false, _recoverArmed = false;
function scheduleRecover() {
  if (_recoverArmed) return;
  _recoverArmed = true;
  const tryNow = async () => {
    if (_retryBusy) return;
    _retryBusy = true;
    clearTimeout(_retryTmr); _retryTmr = null;
    try {
      const s = await apiFetch('/portal/summary', { timeoutMs: 10000 });
      renderSummary(s);                 // 這行成功才算恢復（形狀不完整會丟例外→續重試）
      _recoverArmed = false;
      window.removeEventListener('online', tryNow);
      toast('連線已恢復');
    } catch (e) {
      _retryTmr = setTimeout(tryNow, 30000);   // 還沒好：安靜地下一輪，不重複跳提示
    } finally {
      _retryBusy = false;
    }
  };
  _retryTmr = setTimeout(tryNow, 30000);
  window.addEventListener('online', tryNow);
}

(async function boot() {
  const h = new Date().getHours();
  $('#hello').textContent = (h < 12 ? '早安' : h < 18 ? '午安' : '晚安') + '，' + (user.name || '');
  // 09/11 老闆規格：身分改單字徽章、登出收進徽章選單（名字問候語照舊，資訊不減）
  const whoItems = [{ label: '登出', run: portalLogout }];
  whoBoot({ badge: user.role === 'admin' ? '管' : /後場/.test(user.name || '') ? '後' : '總', name: user.name || '', items: whoItems });
  try {
    // 09/16 懸掛保險（09/15 晚手機卡入口實案）：逾時 10 秒自動重試一次，
    // 第二次再失敗才落到 catch 的降級入口卡——畫面永遠不會卡在空白等待
    let s;
    try { s = await apiFetch('/portal/summary', { timeoutMs: 10000 }); }
    catch (e1) { s = await apiFetch('/portal/summary', { timeoutMs: 10000 }); }
    renderSummary(s);
  } catch (e) {
    // 摘要載入失敗也要能導航：卡片降級為純入口，背景每 30 秒重試自動恢復
    $('#today').textContent = '';
    $('#apps').innerHTML =
      card(ICON_INV, '庫存系統', '', '<p class="muted-sm" style="padding:6px 0;">系統更新中或連線不穩，可先點卡直接進入，稍後會自動恢復。</p>', 'goInv', '進入庫存') +
      card(ICON_HR, '人事評分', '', '<p class="muted-sm" style="padding:6px 0;">系統更新中或連線不穩，可先點卡直接進入，稍後會自動恢復。</p>', 'goHR', '進入人事評分') +
      // 降級時拿不到權威單位代碼，沿用徽章同款推斷（admin 或名字含「後場」／「總店」）——寧可多顯示入口，後端權限仍把關
      (measureVisible(user.role === 'admin', /後場/.test(user.name || '') ? 'FACTORY' : /總店/.test(user.name || '') ? 'STORE_KEELUNG' : null) ? measureCard() : '');
    toast(e.message || '摘要載入失敗');
    if (window.jrPush && user.role !== 'admin') jrPush.renderBar('push-bar', null);   // 降級也讓非 admin 看得到通知狀態（admin 要單位，等摘要回來）
    scheduleRecover();
  }
})();
